var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceBlack24Dp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 7.00001C6.35831 7.00001 5.83331 6.47501 5.83331 5.83334C5.83331 5.19167 6.35831 4.66667 6.99998 4.66667C7.64165 4.66667 8.16665 5.19167 8.16665 5.83334C8.16665 6.47501 7.64165 7.00001 6.99998 7.00001ZM10.5 5.95001C10.5 3.8325 8.95415 2.33334 6.99998 2.33334C5.04581 2.33334 3.49998 3.8325 3.49998 5.95001C3.49998 7.31501 4.63748 9.12334 6.99998 11.2817C9.36248 9.12334 10.5 7.31501 10.5 5.95001ZM6.99998 1.16667C9.44998 1.16667 11.6666 3.04501 11.6666 5.95001C11.6666 7.88667 10.1091 10.1792 6.99998 12.8333C3.89081 10.1792 2.33331 7.88667 2.33331 5.95001C2.33331 3.04501 4.54998 1.16667 6.99998 1.16667Z",
    fill: "#009FE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceBlack24Dp1);
export default __webpack_public_path__ + "static/media/place_black_24dp-1.4b4022206ba83e6e1ef1a84db7703742.svg";
export { ForwardRef as ReactComponent };